<template>
    <div class="sta-table-3">
     <div id="right_choose" class="module g-rbox">			
			<div class="bd">
			<table class="tnum" id="right_num">
				<tbody>
				<tr>
					<td @click="onQuickClick(1)" :class="getNumberActive(1, 'rapidNumbers')"><b class="red">01</b></td>
					<td @click="onQuickClick(11)" :class="getNumberActive(11, 'rapidNumbers')"><b class="green">11</b></td>
					<td @click="onQuickClick(21)" :class="getNumberActive(21, 'rapidNumbers')"><b class="green">21</b></td>
					<td @click="onQuickClick(31)" :class="getNumberActive(31, 'rapidNumbers')"><b class="blue">31</b></td>
					<td @click="onQuickClick(41)" :class="getNumberActive(41, 'rapidNumbers')"><b class="blue">41</b></td>
				</tr>
				<tr>
					<td @click="onQuickClick(2)" :class="getNumberActive(2, 'rapidNumbers')"><b class="red">02</b></td>
					<td @click="onQuickClick(12)" :class="getNumberActive(12, 'rapidNumbers')"><b class="red">12</b></td>
					<td @click="onQuickClick(22)" :class="getNumberActive(22, 'rapidNumbers')"><b class="green">22</b></td>
					<td @click="onQuickClick(32)" :class="getNumberActive(32, 'rapidNumbers')"><b class="green">32</b></td>
					<td @click="onQuickClick(42)" :class="getNumberActive(42, 'rapidNumbers')"><b class="blue">42</b></td>
				</tr>
				<tr>
					<td @click="onQuickClick(3)" :class="getNumberActive(3, 'rapidNumbers')"><b class="blue">03</b></td>
					<td @click="onQuickClick(13)" :class="getNumberActive(13, 'rapidNumbers')"><b class="red">13</b></td>
					<td @click="onQuickClick(23)" :class="getNumberActive(23, 'rapidNumbers')"><b class="red">23</b></td>
					<td @click="onQuickClick(33)" :class="getNumberActive(33, 'rapidNumbers')"><b class="green">33</b></td>
					<td @click="onQuickClick(43)" :class="getNumberActive(43, 'rapidNumbers')"><b class="green">43</b></td>
				</tr>
				<tr>
					<td @click="onQuickClick(4)" :class="getNumberActive(4, 'rapidNumbers')"><b class="blue">04</b></td>
					<td @click="onQuickClick(14)" :class="getNumberActive(14, 'rapidNumbers')"><b class="blue">14</b></td>
					<td @click="onQuickClick(24)" :class="getNumberActive(24, 'rapidNumbers')"><b class="red">24</b></td>
					<td @click="onQuickClick(34)" :class="getNumberActive(34, 'rapidNumbers')"><b class="red">34</b></td>
					<td @click="onQuickClick(44)" :class="getNumberActive(44, 'rapidNumbers')"><b class="green">44</b></td>
				</tr>
				<tr>
					<td @click="onQuickClick(5)" :class="getNumberActive(5, 'rapidNumbers')"><b class="green">05</b></td>
					<td @click="onQuickClick(15)" :class="getNumberActive(15, 'rapidNumbers')"><b class="blue">15</b></td>
					<td @click="onQuickClick(25)" :class="getNumberActive(25, 'rapidNumbers')"><b class="blue">25</b></td>
					<td @click="onQuickClick(35)" :class="getNumberActive(35, 'rapidNumbers')"><b class="red">35</b></td>
					<td @click="onQuickClick(45)" :class="getNumberActive(45, 'rapidNumbers')"><b class="red">45</b></td>
				</tr>
				<tr>
					<td @click="onQuickClick(6)" :class="getNumberActive(6, 'rapidNumbers')"><b class="green">06</b></td>
					<td @click="onQuickClick(16)" :class="getNumberActive(16, 'rapidNumbers')"><b class="green">16</b></td>
					<td @click="onQuickClick(26)" :class="getNumberActive(26, 'rapidNumbers')"><b class="blue">26</b></td>
					<td @click="onQuickClick(36)" :class="getNumberActive(36, 'rapidNumbers')"><b class="blue">36</b></td>
					<td @click="onQuickClick(46)" :class="getNumberActive(46, 'rapidNumbers')"><b class="red">46</b></td>
				</tr>
				<tr>
					<td @click="onQuickClick(7)" :class="getNumberActive(7, 'rapidNumbers')"><b class="red">07</b></td>
					<td @click="onQuickClick(17)" :class="getNumberActive(17, 'rapidNumbers')"><b class="green">17</b></td>
					<td @click="onQuickClick(27)" :class="getNumberActive(27, 'rapidNumbers')"><b class="green">27</b></td>
					<td @click="onQuickClick(37)" :class="getNumberActive(37, 'rapidNumbers')"><b class="blue">37</b></td>
					<td @click="onQuickClick(47)" :class="getNumberActive(47, 'rapidNumbers')"><b class="blue">47</b></td>
				</tr>
				<tr>
					<td @click="onQuickClick(8)" :class="getNumberActive(8, 'rapidNumbers')"><b class="red">08</b></td>
					<td @click="onQuickClick(18)" :class="getNumberActive(18, 'rapidNumbers')"><b class="red">18</b></td>
					<td @click="onQuickClick(28)" :class="getNumberActive(28, 'rapidNumbers')"><b class="green">28</b></td>
					<td @click="onQuickClick(38)" :class="getNumberActive(38, 'rapidNumbers')"><b class="green">38</b></td>
					<td @click="onQuickClick(48)" :class="getNumberActive(48, 'rapidNumbers')"><b class="blue">48</b></td>
				</tr>
				<tr>
					<td @click="onQuickClick(9)" :class="getNumberActive(9, 'rapidNumbers')"><b class="blue">09</b></td>
					<td @click="onQuickClick(19)" :class="getNumberActive(19, 'rapidNumbers')"><b class="red">19</b></td>
					<td @click="onQuickClick(29)" :class="getNumberActive(29, 'rapidNumbers')"><b class="red">29</b></td>
					<td @click="onQuickClick(39)" :class="getNumberActive(39, 'rapidNumbers')"><b class="green">39</b></td>
					<td @click="onQuickClick(49)" :class="getNumberActive(49, 'rapidNumbers')"><b class="green">49</b></td>
				</tr>
				<tr>
					<td @click="onQuickClick(10)" :class="getNumberActive(10, 'rapidNumbers')"><b class="blue">10</b></td>
					<td @click="onQuickClick(20)" :class="getNumberActive(20, 'rapidNumbers')"><b class="blue">20</b></td>
					<td @click="onQuickClick(30)" :class="getNumberActive(30, 'rapidNumbers')"><b class="red">30</b></td>
					<td @click="onQuickClick(40)" :class="getNumberActive(40, 'rapidNumbers')"><b class="red">40</b></td>
				</tr>
        <tr class="first_tr">
          <td colspan="5">
            <b @click="onQuickPlay('单')">单</b>
            <b @click="onQuickPlay('双')">双</b>
            <b @click="onQuickPlay('大')">大</b>
            <b @click="onQuickPlay('小')">小</b>
            <b @click="onQuickPlay('合单')">合单</b>
            <b @click="onQuickPlay('合双')">合双</b>
            <b @click="onQuickPlay('大单')">大单</b>
          </td>
        </tr>
        <tr class="first_tr">
          <td colspan="5">
            <b class="red" @click="onQuickPlay('红波')">红波</b>
            <b class="red" @click="onQuickPlay('红单')">红单</b>
            <b class="red" @click="onQuickPlay('红双')">红双</b>
            <b class="red" @click="onQuickPlay('红大')">红大</b>
            <b class="red" @click="onQuickPlay('红小')">红小</b>
            <b @click="onQuickPlay('大双')">大双</b>
          </td>
        </tr>
        <tr class="first_tr">
          <td colspan="5">
            <b class="blue" @click="onQuickPlay('蓝波')">蓝波</b>
            <b class="blue" @click="onQuickPlay('蓝单')">蓝单</b>
            <b class="blue" @click="onQuickPlay('蓝双')">蓝双</b>
            <b class="blue" @click="onQuickPlay('蓝大')">蓝大</b>
            <b class="blue" @click="onQuickPlay('蓝小')">蓝小</b>
            <b @click="onQuickPlay('小单')">小单</b>
          </td>
        </tr>
        <tr class="first_tr">
          <td colspan="5">
            <b class="green" @click="onQuickPlay('绿波')">绿波</b>
            <b class="green" @click="onQuickPlay('绿单')">绿单</b>
            <b class="green" @click="onQuickPlay('绿双')">绿双</b>
            <b class="green" @click="onQuickPlay('绿大')">绿大</b>
            <b class="green" @click="onQuickPlay('绿小')">绿小</b>
            <b @click="onQuickPlay('小双')">小双</b>
          </td>
        </tr>
        <tr class="first_tr">
          <td colspan="5">
            <b @click="onQuickPlay('鼠')">鼠</b>
            <b @click="onQuickPlay('牛')">牛</b>
            <b @click="onQuickPlay('虎')">虎</b>
            <b @click="onQuickPlay('兔')">兔</b>
            <b @click="onQuickPlay('龙')">龙</b>
            <b @click="onQuickPlay('蛇')">蛇</b>
            <b @click="onQuickPlay('马')">马</b>
            <b @click="onQuickPlay('羊')">羊</b>
            <b @click="onQuickPlay('猴')">猴</b>
            <b @click="onQuickPlay('鸡')">鸡</b>
            <b @click="onQuickPlay('狗')">狗</b>
            <b @click="onQuickPlay('猪')">猪</b>
          </td>
        </tr>
				</tbody>
			</table>
			<table class="su">
			<tbody>
				<tr>
					<td><strong>金额：</strong><input class="t1" id="right_amount" type="text" v-model="rapidValue"></td>
					<td>
          <input class="btn3 co" value="确 定" id="submit_right" @click="bet" type="button">
          <input class="btn3" value="重 置" id="reset_right" type="reset" @click="onResetRapidValue">
          </td>
				</tr>
        <tr>
          <td style="background: #fff;border: none;" colspan="2">
            <textarea placeholder="手动输入或粘贴号码投注。多个号码以空格，逗号或分号隔开。同时支持格式：号码=金额" rows="4" cols="20" v-model="tw" style="border: 1px solid #bfbfbf;margin-left: 2px;width: 196px;height:107px">
            </textarea>
            <input class="btn3 co" value="确 定" id="submit_right" @click="tewei" type="button">
            <input class="btn3" value="重 置" id="reset_right" type="reset" @click="onResetRapidValue1">
          </td>
        </tr>  
			</tbody>
			</table>
			</div>
			<div class="ft"><div class="l"></div><div class="r"></div></div>
			</div>
    </div>
</template>

<script>
import objectPath from 'object-path';
import {mapState} from 'vuex';
import {
  Message
} from 'element-ui';

export default {
  name: "sta_table3",
  data() {
    return {
      rapidValue:'',
      rapidNumbers: [], // 投注的号码数组
      tw:'',
    };
  },
  mounted(){
  },
  computed: {
    ...mapState({
      lhTabData: state => state.home.lhTabData,
      shengxiaoData: state => state.home_PK10.shengxiaoData,
    }),
  },
  methods: {
    tewei1() {
      const RAPID_NUMBER = [];
      let class1 = objectPath.get(this.lhTabData, 'label') || '特码';
      let played_name = objectPath.get(this.lhTabData, 'playedName');
      let class2 = played_name;
      let sub_category_id = objectPath.get(this.lhTabData, 'sub_category_id') || 1;
      if(sub_category_id>3){
        sub_category_id = 1;
      }
      const DEFAULT_NAME = {
        1: '特码A',
        2: '正码A',
        3: '正1特',
      }
      if (!played_name) {
        played_name = DEFAULT_NAME[sub_category_id];
        class2 = DEFAULT_NAME[sub_category_id];
      }
      // 根据需求，如果为正特，played_name为正特
      if (sub_category_id === 3 || played_name === DEFAULT_NAME[3]) {
        played_name = '正特';
      }

      let split = this.tw.split(',');
      let split1 = this.tw.split('.');
      let split2 = this.tw.split(/[\s\n]/);
      let split3 = this.tw.split(';');
      let split4 = this.tw.split('，');
      let split5 = this.tw.split('；');
      //合并split、split1、spli2、spli3、spli4、split5 
      split = split.concat(split1);
      split = split.concat(split2);
      split = split.concat(split3);
      split = split.concat(split4);
      split = split.concat(split5);
      // 去重split
      split = split.filter(function(item, index, arr) {
        return arr.indexOf(item) === index;
      });
      for(let i=0;i<=split.length;i++){
        // 如果split[i]不是undefined，则执行下面的代码
        if(split[i] != undefined){
          let number = split[i].split('=');
          number[0] = Number(number[0]);
          if(number.length == 2 && number[0]>=1 && number[0]<=49){
            RAPID_NUMBER.push({
              class1,
              class2,
              class3: `${number[0]}`,
              money: Number(number[1]),
              played_name,
              status: 1,
            });
          }
        }
      }
      if(RAPID_NUMBER.length<=0){
        Message({message: "格式错误或未输入内容", type: "error"});
        return;
      }
      this.$emit('fastBetF', RAPID_NUMBER);
      this.onQuickReset();
      this.onResetRapidValue1();
    },
    tewei() {
      // 判断tw内容是否有=号
      if(this.tw.indexOf('=') != -1){
          this.tewei1();
      }else{
        let split = this.tw.split(',');
        let split1 = this.tw.split('.');
        let split2 = this.tw.split(/[\s\n]/);
        let split3 = this.tw.split(';');
        let split4 = this.tw.split('，');
        let split5 = this.tw.split('；');
        for(let i=0;i<=split.length;i++){
            let isActive = this['rapidNumbers'].find(key => key == split[i]);
            if( ! isActive){
              this.onQuickClick(split[i]);
            }
        }
        for(let i=0;i<=split1.length;i++){
            let isActive = this['rapidNumbers'].find(key => key == split1[i]);
            if( ! isActive){
              this.onQuickClick(split1[i]);
            }
        }
        for(let i=0;i<=split2.length;i++){
            let isActive = this['rapidNumbers'].find(key => key == split2[i]);
            if( ! isActive){
              this.onQuickClick(split2[i]);
            }
        }
        for(let i=0;i<=split3.length;i++){
            let isActive = this['rapidNumbers'].find(key => key == split3[i]);
            if( ! isActive){
              this.onQuickClick(split3[i]);
            }
        }
        for(let i=0;i<=split4.length;i++){
            let isActive = this['rapidNumbers'].find(key => key == split4[i]);
            if( ! isActive){
              this.onQuickClick(split4[i]);
            }
        }
        for(let i=0;i<=split5.length;i++){
            let isActive = this['rapidNumbers'].find(key => key == split5[i]);
            if( ! isActive){
              this.onQuickClick(split5[i]);
            }
        }
        this.bet();
      }
    },
    // 快速下注 数据还原
    onQuickReset() {
      this.rapidValue = '';
      //this.rapidPlayValues = [];
      this.rapidNumbers = [];
      //this.tw = '';
      //this.rapidPlayValuesObj = [];
    },
    // 清空下单金额
    onResetRapidValue() {
      this.onQuickReset();
    },
    // 清空下单金额
    onResetRapidValue1() {
      this.tw = '';
    },
    // 号码是否选中
    getNumberActive(number, target = 'rapidPlayValues') {
      let isActive = this[target].find(key => key == number);
      return isActive ? 'number-active' : '';
    },
    // 快速点击方法
    quickClickGadget(target, value) {
      const isExist = this[target].find(key => key == value);
      // 判断是否存在
      if (isExist) {
        this[target] = this[target].filter(key => key != value);
      } else {
        this[target].push(value);
      }
    },
    // 玩法lick
    onQuickPlay(play) {
      var NEW_RAPID_NUMBERS = [];
      switch (play) {
        case '单':
          for (let i = 1; i < 50; i++) {
            if (i % 2 === 1) {
              let isActive = this['rapidNumbers'].find(key => key == i);
              if( ! isActive){
                this.onQuickClick(i);
              }
            }
          }
          break;
        case '双':
          for (let i = 1; i < 50; i++) {
            if (i % 2 === 0) {
              let isActive = this['rapidNumbers'].find(key => key == i);
              if( ! isActive){
                this.onQuickClick(i);
              }
            }
          }
          break;
        case '大':
          for (let i = 25; i < 50; i++) {
            let isActive = this['rapidNumbers'].find(key => key == i);
              if( ! isActive){
                this.onQuickClick(i);
            }
          }
          break;
        case '小':
          for (let i = 1; i < 25; i++) {
            let isActive = this['rapidNumbers'].find(key => key == i);
            if( ! isActive){
              this.onQuickClick(i);
            }
          }
          break;
        case '合双':
          NEW_RAPID_NUMBERS = [2, 4, 6, 8, 11, 13, 15, 17, 19, 20, 22, 24, 26, 28, 31, 33, 35, 37, 39, 40, 42, 44, 46, 48];
          break;
        case '合单':
          NEW_RAPID_NUMBERS = [1, 3, 5, 7, 9, 10, 12, 14, 16, 18, 21, 23, 25, 27, 29, 30, 32, 34, 36, 38, 41, 43, 45, 47, 49];
          break;
        case '红大':
          NEW_RAPID_NUMBERS = [29, 30, 34, 35, 40, 45, 46];
          break;
        case '红小':
          NEW_RAPID_NUMBERS = [1, 2, 7, 8, 12, 13, 18, 19, 23, 24];
          break;
        case '红双':
          NEW_RAPID_NUMBERS = [2, 8, 12, 18, 24, 30, 34, 40, 46];
          break;
        case '红单':
          NEW_RAPID_NUMBERS = [1, 7, 13, 19, 23, 29, 35, 45];
          break;
        case '蓝大':
          NEW_RAPID_NUMBERS = [25, 26, 31, 36, 37, 41, 42, 47, 48];
          break;
        case '蓝小':
          NEW_RAPID_NUMBERS = [3, 4, 9, 10, 14, 15, 20];
          break;
        case '蓝双':
          NEW_RAPID_NUMBERS = [4, 10, 14, 20, 26, 36, 42, 48];
          break;
        case '蓝单':
          NEW_RAPID_NUMBERS = [3, 9, 15, 25, 31, 37, 41, 47];
          break;
        case '绿大':
          NEW_RAPID_NUMBERS = [27, 28, 32, 33, 38, 39, 43, 44, 49];
          break;
        case '绿小':
          NEW_RAPID_NUMBERS = [5, 6, 11, 16, 17, 21, 22];
          break;
        case '绿双':
          NEW_RAPID_NUMBERS = [6, 16, 22, 28, 32, 38, 44];
          break;
        case '绿单':
          NEW_RAPID_NUMBERS = [5, 11, 17, 21, 27, 33, 39, 43, 49];
          break;
        case '红波':
          NEW_RAPID_NUMBERS = [1, 2, 7, 8, 12, 13, 18, 19, 23, 24, 29, 30, 34, 35, 40, 45, 46];
          break;
        case '蓝波':
          NEW_RAPID_NUMBERS = [3, 4, 9, 10, 14, 15, 20, 25, 26, 31, 36, 37, 41, 42, 47, 48];
          break;
        case '绿波':
          NEW_RAPID_NUMBERS = [5, 6, 11, 16, 17, 21, 22, 27, 28, 32, 33, 38, 39, 43, 44, 49];
          break;
        case '大单':
          NEW_RAPID_NUMBERS = [25, 27, 29, 31, 33, 35, 37, 39, 41, 43, 45, 47, 49];
          break; 
        case '小单':
          NEW_RAPID_NUMBERS = [1,3,5,7,9,11,13,15,17,19,21,23];
          break; 
        case '大双':
          NEW_RAPID_NUMBERS = [26,28,30,32,34,36,38,40,42,44,46,48];
          break;
        case '小双':
          NEW_RAPID_NUMBERS = [2,4,6,8,10,12,14,16,18,20,22,24];
          break;    
      }
      // 获取生肖号码
      const isShengxiao = this.shengxiaoData.find(item => item.sx === play);
      if (isShengxiao) {
        NEW_RAPID_NUMBERS = isShengxiao.m_number.split(',').map(item => Number(item));
      }
      for(let i=0;i<=NEW_RAPID_NUMBERS.length;i++){
          let isActive = this['rapidNumbers'].find(key => key == NEW_RAPID_NUMBERS[i]);
          if( ! isActive){
            this.onQuickClick(NEW_RAPID_NUMBERS[i]);
          }
      }
    },
    // 号码click点击
    onQuickClick(number) {
      this.quickClickGadget('rapidNumbers', number);
    },
    bet() {
      const RAPID_NUMBER = [];
      let class1 = objectPath.get(this.lhTabData, 'label') || '特码';
      let played_name = objectPath.get(this.lhTabData, 'playedName');
      let class2 = played_name;
      let sub_category_id = objectPath.get(this.lhTabData, 'sub_category_id') || 1;
      if(sub_category_id>3){
        sub_category_id = 1;
        //Message({message: "此玩法不支持快速投注", type: "error"});
        //return;
      }
      if (!this.rapidValue || this.rapidValue<=0) {
        Message({message: "下注错误，未输入金额", type: "error"});
        return;
      }
      if(this.rapidNumbers.length<=0){
        Message({message: "请至少选择一个号码", type: "error"});
        return;
      }
      const DEFAULT_NAME = {
        1: '特码A',
        2: '正码A',
        3: '正1特',
      }
      if (!played_name) {
        played_name = DEFAULT_NAME[sub_category_id];
        class2 = DEFAULT_NAME[sub_category_id];
      }
      // 根据需求，如果为正特，played_name为正特
      if (sub_category_id === 3 || played_name === DEFAULT_NAME[3]) {
        played_name = '正特';
      }
      this.rapidNumbers.forEach(item => {
        RAPID_NUMBER.push({
          class1,
          class2,
          class3: `${item}`,
          money: Number(this.rapidValue),
          played_name,
          status: 1,
        })
      });
      this.$emit('fastBetF', RAPID_NUMBER);
      this.onQuickReset();
      this.onResetRapidValue1();
    }
  }
}
</script>

<style scoped>
::-webkit-input-placeholder {
  color: #000; /* 将颜色改为灰色 */
}

:-moz-placeholder {
  color: #000; /* 将颜色改为灰色 */
}

::-moz-placeholder {
  color: #000; /* 将颜色改为灰色 */
}

:-ms-input-placeholder {
  color: #000; /* 将颜色改为灰色 */
}
/*.g-rbox {
    background: none repeat scroll 0 0 #ffeec0;
}*/
.first_tr td{background:#fff !important;border-top: 1px solid #9e9e9e73;}
.first_tr b{padding:0 1px}
.number-active {
    background: #fffa00 !important;
}
.g-rbox .bd {
    border-color: #9e9e9e73;
    border-style: solid;
    border-width: 1px;
    border-top: none;
}
.g-rbox .bd TABLE {
    width: 100%;
}
.g-rbox .bd .tnum TD {
    border-color: #9e9e9e73;
    border-style: solid;
    border-width: 0 1px 1px 0;
    font-size: 11px;
    font-weight: bold;
    padding: 3px;
    text-align: center;
}
.theme-1 .g-rbox .bd .tnum TD {
    background:#fff6eb;
}
.theme-2 .g-rbox .bd .tnum TD {
    background:#e8f9eb;
}
.theme-3 .g-rbox .bd .tnum TD {
    background:#f9f5fc;
}
.g-rbox .bd .tnum TD:last-child{
  border-right:none;
}
.module .red {
    color: red !important;
}
.module .green {
    color: green !important;
}
.module .blue {
    color: blue !important;
}
#right_choose b {
    cursor: pointer;
}
.g-rbox .su {
    table-layout: fixed;
    width: 100%;
}
.g-rbox .su TD {
    background: none repeat scroll 0 0 #e6cd77;
    border-color: #9e9e9e73;
    border-style: solid;
    border-width: 0 1px 1px 0;
    padding: 2px 0;
    text-align: center;
}
.g-rbox .su STRONG {
    color: #095793;
}
.g-rbox .bd .t1 {
    border-color: #9e9e9e73;
    border-style: solid;
    border-width: 1px;
    padding: 1px;
    width: 47px;
}
.module .cs {
    color: #ff4e00 !important;
    text-decoration: none !important;
}
.g-rbox .bd .cs TABLE {
    width: 100%;
}
.g-rbox .bd .cs TD {
    padding: 1px 0;
}
.g-rbox .bd .cs LABEL {
    padding-left: 0;
}
.module .olive {
    color: #9b6909 !important;
}
#sx_choose {
    border-top: 1px dashed #9b6909;
    table-layout: fixed;
    width: 100%;
}
#sx_choose INPUT {
    margin: 0;
    padding: 0;
}
#sx_choose LABEL {
    display: block;
    margin-right: -2px;
    overflow: hidden;
    width: 32px;
}
#tw_choose {
    border-top: 1px dashed #9b6909;
    table-layout: fixed;
    width: 100%;
}
.g-rbox .bd .t1 {
    border-color: #9e9e9e73;
    border-style: solid;
    border-width: 1px;
    padding: 1px;
    width: 47px;
}
</style>


// WEBPACK FOOTER //
// src/components/c_statistics/sta-table/sta_table3.vue